import { VTimeline } from 'vuetify/lib/components/VTimeline';

var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    [
      _c(
        VTimeline,
        {
          attrs: {
            "align-top": "",
            reverse: !_vm.$vuetify.breakpoint.xs && !_vm.$vuetify.breakpoint.sm,
            dense: _vm.$vuetify.breakpoint.xs || _vm.$vuetify.breakpoint.sm,
          },
        },
        _vm._l(_vm.itens, function (item, index) {
          return _c("app-timeline-item", { key: index, attrs: { value: item } })
        }),
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }